// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"004308ef","113":"7ae2e6e4","142":"5c55e397","189":"1695b8c8","246":"4131b218","279":"8fb2f698","347":"3fa8adae","421":"e4c77039","453":"58adeccf","513":"de5f947a","556":"abd551e0","587":"f7c2b909","766":"e85d4c0c","783":"2977ec9c","796":"3bc04706","905":"88af85ac"}[chunkId] + ".chunk.js";
};